import { render, staticRenderFns } from "./ExitGame.vue?vue&type=template&id=555e5ce4&"
import script from "./ExitGame.vue?vue&type=script&lang=js&"
export * from "./ExitGame.vue?vue&type=script&lang=js&"
import style0 from "./ExitGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports